import React from 'react';
import { Box } from '@mui/material';
import SubscriptionCard from './SubcriptionCard';

function SubscriptionList({ subscriptions }) {
  return (
    <Box sx={{ p: 2, display: 'grid', gridTemplateColumns: { xs: '1fr' }, gap: 2 }}>
      {subscriptions.map((subscription) => (
        <SubscriptionCard
          key={subscription.id}
          title={subscription.subscription_name}
          city={subscription.city}
          sessionsLeft={subscription.remains}
          freeCancellations={subscription.free_cancels}
          dueDate={subscription.due_date}
        />
      ))}
    </Box>
  );
}

export default SubscriptionList;
